import _defineProperty from 'babel-runtime/helpers/defineProperty';

var NAMESPACE = 'td';

var Tooltip = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', _vm._g({ staticClass: "td-tooltip-wrapper" }, _vm.listeners), [_vm._t("default"), _vm._v(" "), _c('div', { directives: [{ name: "show", rawName: "v-show", value: _vm.tooltipVisible, expression: "tooltipVisible" }], staticClass: "td-tooltip", class: 'is-' + _vm.placement, style: _vm.position }, [_c('div', { staticClass: "td-tooltip__inner" }, [_vm._t("content", [_vm._v(_vm._s(_vm.content))])], 2), _vm._v(" "), _c('span', { staticClass: "td-poper__arrow" })])], 2);
  }, staticRenderFns: [],
  name: NAMESPACE + '-tooltip',

  props: {
    content: String,

    offset: {
      type: Object,
      default: function _default() {
        return { x: 0, y: 0 };
      }
    },

    placement: {
      type: String,
      default: 'bottom'
    },

    trigger: String,
    visible: Boolean,

    delay: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      tooltipVisible: this.visible
    };
  },


  computed: {
    listeners: function listeners() {
      var _this = this,
          _ref;

      var showEvent = {
        focus: 'focusin',
        hover: 'mouseenter'
      };

      var hideEvent = {
        focus: 'focusout',
        hover: 'mouseleave'
      };

      return showEvent[this.trigger] ? (_ref = {}, _defineProperty(_ref, showEvent[this.trigger], function () {
        setTimeout(function () {
          _this.tooltipVisible = true;
        }, _this.delay);
      }), _defineProperty(_ref, hideEvent[this.trigger], function () {
        setTimeout(function () {
          _this.tooltipVisible = false;
        }, _this.delay);
      }), _ref) : null;
    },
    position: function position() {
      var _offset = this.offset,
          _offset$x = _offset.x,
          x = _offset$x === undefined ? 0 : _offset$x,
          _offset$y = _offset.y,
          y = _offset$y === undefined ? 0 : _offset$y;


      switch (this.placement) {
        case 'top':
          return { margin: '0 0 -' + y + 'px ' + x + 'px' };
        case 'right':
        case 'bottom':
          return { margin: y + 'px 0 0 ' + x + 'px' };
        case 'left':
          return { margin: y + 'px -' + x + 'px 0 0' };
      }
    }
  },

  watch: {
    visible: function visible(val) {
      this.tooltipVisible = val;
    },
    tooltipVisible: function tooltipVisible(val) {
      this.$emit(val ? 'show' : 'hide');
    },
    trigger: function trigger(val) {
      this.tooltipVisible = false;
    }
  }
};

Tooltip.install = function (Vue) {
  Vue.component(Tooltip.name, Tooltip);
};

export default Tooltip;
